import { render, staticRenderFns } from "./skill.vue?vue&type=template&id=674753c5&scoped=true&"
import script from "./skill.vue?vue&type=script&lang=js&"
export * from "./skill.vue?vue&type=script&lang=js&"
import style0 from "./skill.vue?vue&type=style&index=0&id=674753c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674753c5",
  null
  
)

export default component.exports